export const INSTALLATION_DEFAULT_CONSTANTS = {
    installationDesc1: '',
    installationDesc2: '',
    installationDesc3: '',
    installationDesc4: '',
    installationDesc5: '',
    wasCreatedFromImport: false,
};

export enum ElevationInstallationFieldIds {
    ReferencePoint = 'elevation-reference-point',
    Datum = 'elevation-height',
    PhysicalOffset = 'elevation-physical-offset',
}
